import React, { Component } from 'react';
import classNames from 'classnames';
import DocumentStore from '../../components/App/Stores/DocumentStore';
import DocumentDownloader from '../../components/Documents/DocumentDownloader';
import { inject, observer } from 'mobx-react';
import * as TRANSITION from '../../components/App/Constants/Transition';
import * as TELEMETRY from '../../components/App/Constants/Telemetry';
import * as EVENTS from '../../components/App/Constants/Events';
import {
  RESOURCE_SECTION_DAM_PATH,
  RESOURCE_SECTION_LABEL,
  RESOURCE_TELEMETRY_PROPERTIES,
} from '../../components/App/Constants/Resources';

interface Props {
  documentStore: DocumentStore;
}

interface State {
  value: number;
  isDisplayLoadingAnimation: boolean;
}

const RESOURCE_TABS = [
  {
    label: RESOURCE_SECTION_LABEL.GENERAL_INFORMATION,
    damPath: RESOURCE_SECTION_DAM_PATH.GENERAL_INFORMATION,
  },
  {
    label: RESOURCE_SECTION_LABEL.NZFAP_PLUS,
    damPath: RESOURCE_SECTION_DAM_PATH.NZFAP_PLUS,
  },
];

@inject('documentStore')
@observer
class Documents extends Component<Props, State> {
  private timeout: any;

  constructor(props: Props) {
    super(props);
    this.state = {
      value: 0,
      isDisplayLoadingAnimation: false,
    };
  }

  componentDidMount = () => {
    const { documentStore } = this.props;
    documentStore.setActiveDamPath(RESOURCE_SECTION_DAM_PATH.GENERAL_INFORMATION);
    documentStore.getDocumentList();

    const element = document.getElementById('c-documents');
    element!.addEventListener(EVENTS.MOUSE_SCROLL, this.trackScrolling.bind(this));
  }

  getResourceTelemetryProperties = () => {
    const activeTab = RESOURCE_TABS[this.state.value];
    return {
      [RESOURCE_TELEMETRY_PROPERTIES.RESOURCE_SECTION]: activeTab.label,
    };
  }

  handleSectionChange = (value: number) => {
    if (value === this.state.value) {
      return;
    }

    const { documentStore } = this.props;
    const selectedTab = RESOURCE_TABS[value];

    this.setState({ value });
    documentStore.setActiveDamPath(selectedTab.damPath);
    documentStore.resetDocumentList();
    documentStore.getDocumentList();
  }

  trackScrolling = (event: any) => {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      const _node: any = event.target;
      const { documentStore } = this.props;
      const scrollTop = Math.ceil(_node.scrollTop);
      const isBottomOfDiv =
        _node.scrollHeight - scrollTop <= _node.clientHeight;
      const _element = document.getElementById('c-documents');

      if (isBottomOfDiv && !documentStore.isDocListAllLoaded && _node.scrollTop > 0) {
        this.setState({ isDisplayLoadingAnimation: true });
        window.telemetry.logEvent(
          TELEMETRY.EVENTS.RESOURCE_PAGINATION_LOAD,
          undefined,
          this.getResourceTelemetryProperties(),
        );
        documentStore.getDocumentList().then(() => {
          this.setState({ isDisplayLoadingAnimation: false });
          _element!.scrollTop = scrollTop;
        });
      }
    }, TRANSITION.TIMELINE_SCROLL_DELAY);
  }

  render() {
    const { documentStore } = this.props;
    const activeTab = RESOURCE_TABS[this.state.value];

    return (
      <div className="c-documents" id="c-documents">
        <div className="c-documents__list">
          <p className="c-documents__list-header">RESOURCES</p>
          <div className="c-documents__tabs" role="tablist">
            {RESOURCE_TABS.map((tab, index) => (
              <button
                key={tab.damPath}
                type="button"
                role="tab"
                aria-selected={this.state.value === index}
                className={classNames('c-documents__tab', {
                  'c-documents__tab--active': this.state.value === index,
                })}
                onClick={() => this.handleSectionChange(index)}
              >
                {tab.label}
              </button>
            ))}
          </div>
          {documentStore.docList &&
            documentStore.docList.map((resourceDocument) => (
              <DocumentDownloader
                key={resourceDocument.id}
                document={resourceDocument}
                documentStore={documentStore}
                resourceSection={activeTab.label}
              />
            ))}
        </div>
      </div>
    );
  }
}

export default Documents;
